export default __webpack_public_path__ + "static/media/EasterDay_16.135b276a.png";